import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { TranslationProvider, useTranslation } from '@ibk/shared-translation';
import { ChargesPDFViewer } from '../../components/ChargesPDFViewer';
import { pagamentosTranslations } from '../../translations';
import styles from './ChargesPDF.module.css';
export function ChargesPDFBase() {
    const { slipId } = useParams();
    const navigate = useNavigate();
    const { t } = useTranslation();
    const dataTestId = 'charges-pdf-page';
    const handleBack = () => {
        navigate('/conta-pj/receber');
    };
    if (!slipId) {
        return (_jsx("div", { className: styles.container, "data-testid": `${dataTestId}-error`, children: _jsx("div", { className: styles.error, children: _jsx("p", { children: t('charges-pdf-viewer.error') }) }) }));
    }
    return (_jsx("main", { className: styles.main, "data-testid": dataTestId, children: _jsx(ChargesPDFViewer, { slipId: slipId, onBack: handleBack, dataTestId: `${dataTestId}-viewer` }) }));
}
export function ChargesPDF() {
    return (_jsx(TranslationProvider, { translations: pagamentosTranslations, defaultLanguage: 'pt-BR', children: _jsx(ChargesPDFBase, {}) }));
}
